import { find } from "lodash";

export default function getCurriculumSettings(user, curriculumSlug) {
  if (!user || !curriculumSlug) {
    return null;
  }

  const selectedProfile = find(
    user.classrooms,
    (profile) => profile.id === user.selectedClassroomId,
  );

  if (!selectedProfile) {
    return null;
  }

  return find(
    selectedProfile.curriculumSettings,
    (settings) => String(settings.curriculumId) === curriculumSlug,
  );
}
